// extracted by css-extract-rspack-plugin
export default {"cls1":"BottomSection-cls1_UJg","cls2":"BottomSection-cls2_U_C BottomSection-cls1_UJg"};